import { render, staticRenderFns } from "./Quit.vue?vue&type=template&id=558e56be&"
import script from "./Quit.vue?vue&type=script&lang=js&"
export * from "./Quit.vue?vue&type=script&lang=js&"
import style0 from "./Quit.vue?vue&type=style&index=0&id=558e56be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports